<template>
    <tr>
        <td v-if="showColumn('name')">
            {{name}}
        </td>
        <td v-if="showColumn('payload')">
            {{ $t(`log.activity.${payload.toLowerCase()}`) }}{{extensionName}}
        </td>
        <td v-if="showColumn('toVersion')">
          {{toVersion}}
        </td>
        <td v-if="showColumn('date')">
            {{dateFormated}}
        </td>
    </tr>
</template>

<script>

import moment from 'moment'
import { mapGetters } from 'vuex'

export default {

  name: 'ActivityItem',

  props: [
    'id',
    'name',
    'type',
    'result',
    'date',
    'payload',
    'extension_name',
    'to_version'
  ],

  computed: {

    ...mapGetters('local', ['getLogsColumns']),

    dateFormated () {
      return moment(this.date).format('DD.MM.YYYY HH:mm')
    },

    extensionName () {
      if (this.extension_name !== undefined && this.extension_name !== '') {
        return ': ' + this.extension_name
      }

      return ''
    },

    toVersion () {
      if (this.to_version !== undefined && this.to_version !== '') {
        return this.to_version
      }

      return '-'
    }
  },

  methods: {
    showColumn (name) {
      return this.getLogsColumns.indexOf(name) !== -1
    }
  }
}
</script>
